import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { Country, PhoneFormatsType } from '@modules/global/types';

import CountrySelect from '@components/CountrySelect';
import InputMask from '@components/InputMask';

import style from './Phone.scss';

const cn = bemCssModules(style, 'Phone');
const ti = getTestId('Phone');

export type TPhone = {
  phone: string;
  countries: Country[];
  countryCode: PhoneFormatsType;
  setCountryCode: (value: PhoneFormatsType) => void;
  isLoading: boolean;
  setPhone: (value: string) => void;
  error?: string | boolean;
};

const getMaskitoMask = (str?: string) => {
  if (!str) return [];
  return str.split('').map(char => (char === ' ' ? ' ' : /[\d]/));
};

const transformMaskIntoPlaceholder = (arr: (RegExp | ' ')[]) => {
  return arr.length > 0
    ? arr
        .map(item => (item instanceof RegExp && item.toString() === '/[\\d]/' ? '0' : ' '))
        .join('')
    : '';
};

export const Phone: CustomFC<TPhone> = props => {
  const { className, phone, isLoading, countryCode, setPhone, setCountryCode, error, countries } =
    props;

  const { t } = useTranslation();

  const getCountry = (code: string) => {
    return countries.find(el => el.code === code);
  };

  const libCountriesMask = getCountry(countryCode || '')?.phone_mask;
  const mask = getMaskitoMask(libCountriesMask);

  const handleChangeCountry = (code: PhoneFormatsType) => {
    setCountryCode(code);
  };

  const handleChangePhone = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(event.target.value);
  };

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = event => {
    handleChangePhone(event);
  };

  const isUSCode = countryCode === 'us';
  const placeholderString = transformMaskIntoPlaceholder(mask);

  const maskOptions = mask.length > 0 ? { mask } : { mask: /^\d+$/ };

  return (
    <>
      <div className={cn({ isUSCode }, [className])} data-testid={ti()}>
        <CountrySelect
          countries={countries}
          value={countryCode}
          onSelectCountry={handleChangeCountry}
          placeholder={t('public.region.placeholder')}
          label={t('public.region.label')}
          className={cn('phone-select')}
          classNameButton={cn('phone-value')}
        />

        <InputMask
          inputMode="tel"
          value={phone}
          maskOptions={maskOptions}
          onChange={handleChange}
          className={cn('input')}
          autoFocus
          type="tel"
          name="phone"
          placeholder={placeholderString}
          label={t('public.phone_label')}
          isLoading={isLoading}
          error={error}
          autoComplete="tel"
        />
      </div>
      {isUSCode && (
        <div className={cn('sms-notification', ['small'])}>
          {t('public.phone.sms_notification')}
        </div>
      )}
    </>
  );
};

export default Phone;
